import "./sidebar.scss";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import InsertChartIcon from "@mui/icons-material/InsertChart";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import EventNoteIcon from "@mui/icons-material/EventNote";
import DescriptionIcon from "@mui/icons-material/Description";
import { Link, useLocation } from "react-router-dom";
import { DarkModeContext } from "../../context/darkModeContext";
import { AuthContext } from "../../context/AuthContext";
import { signOut } from "firebase/auth";
import { useContext } from "react";
import { getAuth } from "firebase/auth";

const Sidebar = () => {
  const { dispatch } = useContext(DarkModeContext);
  const { dispatch: authDispatch } = useContext(AuthContext);
  const auth = getAuth();
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname === path;
  };

  const handleLogout = async () => {
    try {
      console.log("Manual logout initiated");

      // Sign out from Firebase
      await signOut(auth);

      // Clear local state - the auth state listener will handle the rest
      authDispatch({ type: "LOGOUT" });
      localStorage.removeItem("user");
      localStorage.removeItem("authToken");

      console.log("Manual logout completed");
    } catch (error) {
      console.error("Error during logout:", error);
      // Force logout even if Firebase signOut fails
      authDispatch({ type: "LOGOUT" });
      localStorage.removeItem("user");
      localStorage.removeItem("authToken");
    }
  };

  return (
    <div className="sidebar">
      <div className="top">
        <Link to="/" style={{ textDecoration: "none" }}>
          <span className="logo">KPCB LTD</span>
        </Link>
      </div>
      <hr />
      <div className="center">
        <ul>
          <Link to="/" style={{ textDecoration: "none" }}>
            <li className={isActive("/") ? "active" : ""}>
              <DashboardIcon className="icon" /> <span>Dashboard</span>
            </li>
          </Link>
          <Link to="/users" style={{ textDecoration: "none" }}>
            <li className={isActive("/users") ? "active" : ""}>
              <PersonOutlineIcon className="icon" />
              <span>Shareholders</span>
            </li>
          </Link>
          <Link to="/all-transactions" style={{ textDecoration: "none" }}>
            <li className={isActive("/all-transactions") ? "active" : ""}>
              <InsertChartIcon className="icon" /> <span>Stats</span>
            </li>
          </Link>
          <Link to="/dividend" style={{ textDecoration: "none" }}>
            <li className={isActive("/dividend") ? "active" : ""}>
              <AccountBalanceWalletIcon className="icon" />
              <span>Dividend</span>
            </li>
          </Link>
          <Link to="/attendance" style={{ textDecoration: "none" }}>
            <li className={isActive("/attendance") ? "active" : ""}>
              <EventNoteIcon className="icon" />
              <span>AGM Attendance</span>
            </li>
          </Link>
          <Link to="/certificates" style={{ textDecoration: "none" }}>
            <li className={isActive("/certificates") ? "active" : ""}>
              <DescriptionIcon className="icon" />
              <span>Certificates</span>
            </li>
          </Link>
          <li>
            <NotificationsNoneIcon className="icon" />
            <span>Notifications</span>
          </li>

          <p className="title">USER</p>
          <Link to="/profile" style={{ textDecoration: "none" }}>
            <li className={isActive("/profile") ? "active" : ""}>
              <AccountCircleOutlinedIcon className="icon" />
              <span>Profile</span>
            </li>
          </Link>

          <li onClick={handleLogout}>
            <ExitToAppIcon className="icon" />
            <span>Logout</span>
          </li>
        </ul>
      </div>
      <div className="bottom">
        <div
          className="colorOption"
          onClick={() => dispatch({ type: "LIGHT" })}
        ></div>
        <div
          className="colorOption"
          onClick={() => dispatch({ type: "DARK" })}
        ></div>
      </div>
    </div>
  );
};

export default Sidebar;
